import React from 'react';
import { ReactComponent as ReceivedIcon } from '../../assets/icons/agenda.svg';
import { ReactComponent as ReviewIcon } from '../../assets/icons/review.svg';
import { ReactComponent as PriorAuthIcon } from '../../assets/icons/prior.svg';
import { ReactComponent as ProcessIcon } from '../../assets/icons/process.svg';
import { ReactComponent as CopayIcon } from '../../assets/icons/copay.svg';
import { ReactComponent as ScheduleIcon } from '../../assets/icons/schedule.svg';
import { ReactComponent as QAIcon } from '../../assets/icons/qa.svg';
import { ReactComponent as ScriptIcon } from '../../assets/icons/script.svg';
import { ReactComponent as ShippedIcon } from '../../assets/icons/shipped.svg';
import { ReactComponent as DoneIcon } from '../../assets/icons/done.svg';
import { ReactComponent as CancelledIcon } from '../../assets/icons/cancelled.svg';
import { ReactComponent as RefileIcon } from '../../assets/icons/refile.svg';
import { ReactComponent as VisaLogoSvg } from '../../assets/icons/visa-logo.svg';
import { ReactComponent as MastercardLogoSvg } from '../../assets/icons/Mastercard-logo.svg';
import { ReactComponent as DiscoverLogoSvg } from '../../assets/icons/Discover-logo.svg';
import { ReactComponent as JCBLogoSvg } from '../../assets/icons/JCB-logo.svg';
import { ReactComponent as AMEXLogoSvg } from '../../assets/icons/AMEX-logo.svg';
import { ReactComponent as UnionPayLogoSvg } from '../../assets/icons/UnionPay-logo.svg';
import { ReactComponent as PayPalLogoSvg } from '../../assets/icons/PayPal_logo.svg';

export const stateOptions = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VI',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const specOptions = [
  'Internal Medicine',
  'Home Health',
  'Hospice',
  'Skilled Nursing Center',
  'Assisted Living',
  'Hospital',
  'Residential Living',
  'Oncology',
  'Rheumatology',
  'Dermatology',
  'Nephrology',
  'Neurology',
  'Gastroenterology',
  'Allergy',
  'Infectious Disease',
  'Transplant',
  'Orthopedic',
  'Endocrinology',
  'Urology',
  'Cardiology',
  'Hepatology',
  'Pulmonology',
];

export const locationOptions = ['Los Angeles', 'Miami'];

export const statuses = [
  {
    name: 'Received',
    icon: <ReceivedIcon />,
  },
  {
    name: 'Review',
    icon: <ReviewIcon />,
  },
  {
    name: 'Prior Auth',
    icon: <PriorAuthIcon />,
  },
  {
    name: 'Process',
    icon: <ProcessIcon />,
  },
  {
    name: 'Copay Assistance',
    icon: <CopayIcon />,
  },
  {
    name: 'Schedule',
    icon: <ScheduleIcon />,
  },
  {
    name: 'QA',
    icon: <QAIcon />,
  },
  {
    name: 'Fill',
    icon: <ScriptIcon />,
  },
  {
    name: 'Shipped',
    icon: <ShippedIcon />,
  },
  {
    name: 'Done',
    icon: <DoneIcon />,
  },
  {
    name: 'Cancelled',
    icon: <CancelledIcon />,
  },
  {
    name: 'Refill',
    icon: <RefileIcon />,
  },
];

export const insuranceTemplate = [
  {
    path: 'InsPlan',
    label: 'Plan',
    type: 'input',
    backPath: 'plan',
  },
  {
    path: 'InsBIN',
    label: 'BIN',
    type: 'input',
    backPath: 'BIN',
  },
  {
    path: 'InsPCN',
    label: 'PCN',
    type: 'input',
    backPath: 'PCN',
  },
  {
    path: 'InsID',
    label: 'ID',
    type: 'input',
    backPath: 'insID',
  },
  {
    path: 'InsGroup',
    label: 'Group',
    type: 'input',
    backPath: 'insGroup',
  },
  {
    path: 'InsType',
    label: 'Type',
    type: 'select',
    options: ['Medicare Part B', 'Medicare Part D', 'Medicaid', 'Commercial', 'Patient Pay'],
    backPath: 'insType',
  },
];

export const PatientAndScriptTabHeader = [
  {
    name: 'File',
    path: 'title',
  },
  {
    name: 'Date Attached',
    path: 'createdAt',
  },
  {
    name: 'Attached By',
    path: 'attachedBy',
  },
  {
    name: 'Type',
    path: 'type',
  },
];

export const scheduleOptions = [
  'C1',
  'C2',
  'C3',
  'C4',
  'C5',
];

export const CardIcon = {
  Visa: <VisaLogoSvg />,
  MasterCard: <MastercardLogoSvg />,
  Discover: <DiscoverLogoSvg />,
  JCB: <JCBLogoSvg />,
  AMEX: <AMEXLogoSvg />,
  UnionPay: <UnionPayLogoSvg />,
  PayPal: <PayPalLogoSvg />,
};

export const possiblePersonsStatusList = ['toContact', 'contacting', 'leftVoicemail', 'needFollowUp',
  'needToBeTransferred', 'received', 'rejected'];

export const personStatusPosition = {
  toContact: 0,
  contacting: 1,
  leftVoicemail: 2,
  needFollowUp: 3,
  needToBeTransferred: 4,
  received: 5,
  rejected: 6,
};
